import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import T from 'components/common/translations/Translate';
import { connect } from 'react-redux';
import HeaderBack from 'components/components/account/components/HeaderBack';
import withRouter from 'components/components/common/withRouter';
import { setUserLogout } from 'components/actions/authActions';
import isWindow from 'components/common/helpers/isWindow';

class Pricing extends Component {

  render() {
    const { isLogged } = this.props;

    return (
      <div className="content content--lp content--lp-text">
        {isLogged &&
          <HeaderBack
            locale={this.props.locale}
            name="Help"
            link="routes.url.help"
            title="content.layout.sidebarAndHeader.backToHelpTitle"
            className="header-back--lp" />
        }

        <div className="row row--text">
          <div className="headline headline--subpage">
            <h1><T>content.landing.pricing.title</T></h1>
            <p><T>content.landing.pricing.desc</T></p>
          </div>

          <div className="price-list">
            <h4></h4>

            <table className="tab--pricing">
              <thead>
                <tr>
                  <th><T>content.landing.pricing.busStop.column</T></th>
                  <th className="price"><T>content.landing.pricing.adults</T></th>
                  <th className="price"><T>content.landing.pricing.students</T></th>
                  <th className="price"><T>content.landing.pricing.teenagers</T></th>
                  <th className="price"><T>content.landing.pricing.seniors</T></th>
                  <th className="price"><T>content.landing.pricing.kids</T></th>
                </tr>
              </thead>

              <tfoot>
                <tr>
                  <td colSpan="6">
                    <p><T>content.landing.pricing.info</T></p>
                  </td>
                </tr>
              </tfoot>

              <tbody>
                <tr>
                  <td>Horten Fergekai</td>
                  <td>230</td>
                  <td>190</td>
                  <td>190</td>
                  <td>190</td>
                  <td>170</td>
                </tr>
                <tr>
                  <td>Drammen Bangeløkka</td>
                  <td>220</td>
                  <td>170</td>
                  <td>170</td>
                  <td>170</td>
                  <td>170</td>
                </tr>
                <tr>
                  <td>Asker Hagaløkka</td>
                  <td>250</td>
                  <td>200</td>
                  <td>200</td>
                  <td>200</td>
                  <td>170</td>
                </tr>
                <tr>
                  <td>Høvik Stasjon/Kirke</td>
                  <td>280</td>
                  <td>220</td>
                  <td>220</td>
                  <td>220</td>
                  <td>170</td>
                </tr>
                <tr>
                  <td>Lysaker</td>
                  <td>280</td>
                  <td>220</td>
                  <td>220</td>
                  <td>220</td>
                  <td>170</td>
                </tr>
                <tr>
                  <td>Sjølyst</td>
                  <td>280</td>
                  <td>220</td>
                  <td>220</td>
                  <td>220</td>
                  <td>170</td>
                </tr>
                <tr>
                  <td>Oslo Bussterminal</td>
                  <td>280</td>
                  <td>220</td>
                  <td>220</td>
                  <td>220</td>
                  <td>170</td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    isLogged: state.app.isLogged
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    { setUserLogout }
  )(Pricing));
